import { useMutation } from '@tanstack/react-query';

import { StudyShareModel } from 'models';

import { apiClient } from 'core/api/globals';

import { AuthenticationScheme, useAssertFetchPermitted } from 'features/auth';

export function useMutationStudyShares() {
  const activeScheme = useAssertFetchPermitted([AuthenticationScheme.OIDC, AuthenticationScheme.SHARE]);

  const addStudyShareMutation = useMutation({
    mutationFn: async (share: StudyShareModel) => {
      return apiClient.studyShare.addStudyShare(share, activeScheme === AuthenticationScheme.SHARE ? 'share-required' : 'msal-required');
    },
  });

  return {
    addStudyShareMutation,
  };
}
